import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { StateLanguage } from '../../languages/config/StateLanguage';

interface DocumentNavigationProps {
  navKey: string;
  currentId: string;
  companyId: string;
  basePath: string;
}

const DocumentNavigation: React.FC<DocumentNavigationProps> = ({ navKey, currentId, companyId, basePath }) => {
  const navigate = useNavigate();
  const {lang} = StateLanguage();

  const [prevId, setPrevId] = useState<string | null>(null);
  const [nextId, setNextId] = useState<string | null>(null);
  const [position, setPosition] = useState<{ current: number; total: number } | null>(null);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(navKey);
      if (!raw) return;
      const nav = JSON.parse(raw);
      if (nav.company_id !== companyId) return;
      const ids: string[] = nav.ids || [];
      const idx = ids.indexOf(currentId);
      if (idx === -1) return;
      setPrevId(idx > 0 ? ids[idx - 1] : null);
      setNextId(idx < ids.length - 1 ? ids[idx + 1] : null);
      setPosition({ current: idx + 1, total: ids.length });
    } catch {
      // silent
    }
  }, [navKey, currentId, companyId]);

  if (!position) return null;

  return (
    <div className="d-flex align-items-center gap-2">
      <button
        className="btn btn-sm btn-light-primary"
        disabled={!prevId}
        onClick={() => prevId && navigate(basePath + prevId)}
      >
        <i className="bi bi-chevron-left fs-6 me-1"></i>
        {lang.labels.previous}
      </button>
      <span className="text-muted fs-7 text-nowrap">{position.current} / {position.total}</span>
      <button
        className="btn btn-sm btn-light-primary"
        disabled={!nextId}
        onClick={() => nextId && navigate(basePath + nextId)}
      >
        {lang.labels.next}
        <i className="bi bi-chevron-right fs-6 ms-1"></i>
      </button>
    </div>
  );
};

export default DocumentNavigation;
